// extracted by mini-css-extract-plugin
export default {"editor":"FinishEditor_editor__vwYJN","label":"FinishEditor_label__xryEd","name":"FinishEditor_name__lG00y","designer":"FinishEditor_designer__BCBb6","tab":"FinishEditor_tab__328X+"};